.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px 8px;
  width: 480px;
}

.row {
  align-items: center;
  display: flex;
  gap: 8px;
}

.suggestions {
  display: flex;
  flex-direction: column;
  gap: 4px;
  list-style: none;
  margin: 0;
  max-height: 160px;
  overflow-y: auto;
  padding: 0;
}

.suggestion-item {
  align-items: stretch;
  display: flex;
}

.suggestion-empty {
  color: var(--color-text-muted);
  font-size: 12px;
  padding: 4px 0;
}

.stars {
  display: flex;
  gap: 4px;
}

.star-icon {
  color: var(--color-border-strong, #d4d4d8);
  height: 28px;
  width: 28px;
}

.star-icon-is-filled {
  color: var(--color-warning-dot, #eab308);
  fill: currentColor;
}

.rating-current {
  color: var(--color-text-muted);
  font-size: 12px;
  margin-top: 4px;
}
